import { ReactNode, useMemo } from 'react';

import { UserDetailsErrorContext } from './UserDetailsErrorContext';

interface UserDetailsErrorProviderProps {
  userDetailsError?: boolean;
  userBalanceError?: boolean;
  children: ReactNode;
}

export const UserDetailsErrorProvider = ({ userDetailsError = false, userBalanceError = false, children }: UserDetailsErrorProviderProps) => {
  const errorContextValue = useMemo(() => ({ userBalanceError, userDetailsError }), [userBalanceError, userDetailsError]);

  return <UserDetailsErrorContext.Provider value={errorContextValue}>{children}</UserDetailsErrorContext.Provider>;
};
